import User1 from "../../assets/images/authorImg1.png";
import User2 from "../../assets/images/authorImg2.png";
import User3 from "../../assets/images/authorImg1.png";
import User4 from "../../assets/images/authorImg2.png";
import NominationIcon1 from "../../assets/images/nominationImg1.svg";
import NominationIcon2 from "../../assets/images/nominationImg2.svg";
import NominationIcon3 from "../../assets/images/nominationImg3.svg";

export const GoverningCouncilData = [
  {
    name: "Prof. Dr. Micheal Anderson",
    role: "Chairman, GAC",
    img: User1,
    education: "Ph.D. Research Methodology",
    awards: "20+ Years Experience",
    publication: "Global Research Networks",
  },
  {
    name: "Prof. Dr. Sarah Chen",
    role: "Vice-Chairman, GAC MIT",
    img: User2,
    education: "Ph.D. Research Methodology",
    awards: "20+ Years Experience",
    represented: "Global Research Networks",
  },
  {
    name: "Prof. Dr. James Wilson",
    role: "Secretary, GAC",
    img: User3,
    education: "Ph.D. Research Methodology",
    scope: "20+ Years Experience",
    policy: "Global Research Networks",
  },
];
export const NationalAdvisorsData = [
  {
    name: "Dr. Emily Watson",
    field: "Science & Technology",
    img: User1,
    university: "Stanford University",
    tag: "AI & Machine Learning",
  },
  {
    name: "Prof. David Kumar",
    field: "Social Sciences",
    img: User2,
    university: "Stanford University",
    tag: "AI & Machine Learning",
  },
  {
    name: "Dr. Maria Rodriguez",
    field: "Life Sciences",
    img: User3,
    university: "Stanford University",
    tag: "AI & Machine Learning",
  },
  {
    name: "Prof. Robert Singh",
    field: "Engineering",
    img: User4,
    university: "Stanford University",
    tag: "AI & Machine Learning",
  },
];

export const ZonalCoordinatorData = [
  {
    zone: "North Zone",
    stateCount: "8 states",
    doctorList: [
      {
        name: "Dr. Rajesh Sharma",
        designation: "Zonal Coordinator",
        state: "Delhi",
      },
      {
        name: "Prof. Ankita Gupta",
        designation: "State Coordinator",
        state: "Punjab",
      },
    ],
  },
  {
    zone: "South Zone",
    stateCount: "8 states",
    doctorList: [
      {
        name: "Dr. Rajesh Sharma",
        designation: "Zonal Coordinator",
        state: "Delhi",
      },
      {
        name: "Prof. Ankita Gupta",
        designation: "State Coordinator",
        state: "Punjab",
      },
    ],
  },
  {
    zone: "West Zone",
    stateCount: "8 states",
    doctorList: [
      {
        name: "Dr. Rajesh Sharma",
        designation: "Zonal Coordinator",
        state: "Delhi",
      },
      {
        name: "Prof. Ankita Gupta",
        designation: "State Coordinator",
        state: "Punjab",
      },
    ],
  },
];

export const nominationFormData = [
  {
    img: NominationIcon1,
    title: "GAC Nomination",
    desc: "Governing Academic Council",
    id: 1,
    featureList: [
      "Ph.D. + 15 years experience",
      "50+ research publications",
      "Administrative experience",
    ],
    buttonText: "Apply for GAC",
  },
  {
    img: NominationIcon2,
    title: "National Advisor",
    desc: "Domain Expert Position",
    id: 2,
    featureList: [
      "Recognized domain expertise",
      "International recognition",
      "Policy influence experience",
    ],
    buttonText: "Apply as Advisor",
  },
  {
    img: NominationIcon3,
    title: "Coordinator Role",
    desc: "Zonal/State Leadership",
    id: 3,
    featureList: [
      "Regional network presence",
      "Leadership experience",
      "Community engagement",
    ],
    buttonText: "Apply for GAC",
  },
];

export const executiveComittiesData = [
  {
    title: "Research & Publications Committee",
    items: [
      {
        name: "Committee Members",
        count: 12,
      },
      {
        name: "Active Projects",
        count: 8,
      },
      {
        name: "Publications Reviewed",
        count: 45,
      },
    ],
  },
  {
    title: "Membership & Outreach Committee",
    items: [
      {
        name: "Committee Members",
        count: 12,
      },
      {
        name: "Active Projects",
        count: 8,
      },
      {
        name: "Publications Reviewed",
        count: 45,
      },
    ],
  },
  {
    title: "Events & Knowledge Series Committee",
    items: [
      {
        name: "Committee Members",
        count: 12,
      },
      {
        name: "Active Projects",
        count: 8,
      },
      {
        name: "Publications Reviewed",
        count: 45,
      },
    ],
  },
  {
    title: "Ethics & Standards Committee",
    items: [
      {
        name: "Committee Members",
        count: 12,
      },
      {
        name: "Active Projects",
        count: 8,
      },
      {
        name: "Publications Reviewed",
        count: 45,
      },
    ],
  },
];
